import MatchedMap from 'utilities/src/matchedMap';

import { ThemeEnum, useTheme, useThemeContext } from 'ui/src/components/Theme';
import { FormTheme } from 'ui/src/components/Form';

import footerSubscriptionCommonTheme from './_common';

import footerSubscriptionBlogTheme from './_blog';
import footerSubscriptionSiteTheme from './_site';

const footerSubscriptionFormClasses = new MatchedMap([
  [ThemeEnum.Blog, footerSubscriptionBlogTheme],
  [ThemeEnum.Site, footerSubscriptionSiteTheme],
]);

const footerSubscriptionTheme = new MatchedMap([
  [ThemeEnum.Blog, FormTheme.Dark],
  [ThemeEnum.Site, FormTheme.Light],
]);

const useFooterSubscriptionFormTheme = () => {
  const { currentTheme } = useThemeContext();
  return {
    classes: useTheme(footerSubscriptionCommonTheme, footerSubscriptionFormClasses),
    theme: footerSubscriptionTheme.get(ThemeEnum[currentTheme]),
  };
};

export default useFooterSubscriptionFormTheme;
